import { ArraySchema, EntitySchema } from 'Lib/schemas';

import { PURCHASES_ENTITY_KEY } from './entityKeys';

export const PRODUCT_TYPE_PLUS = 'plus';
export const PRODUCT_TYPE_GOLD = 'gold';
export const PRODUCT_TYPE_PLATINUM = 'platinum';
export const PRODUCT_TYPE_SELECT_SUBSCRIPTION = 'select_subscription';

export const PRODUCT_TYPE_BOOST = 'boost';
export const PRODUCT_TYPE_BOUNCER_BYPASS = 'bouncerbypass';
export const PRODUCT_TYPE_PRIMETIME_BOOST = 'primetimeboost';
export const PRODUCT_TYPE_SUPERBOOST = 'superboost';
export const PRODUCT_TYPE_SUPERLIKE = 'superlike';

export const PRODUCT_TYPE_READ_RECEIPT = 'readreceipt';
export const PRODUCT_TYPE_SWIPE_NOTE = 'swipenote';

export const PRODUCT_TYPE_PRIORITY_LIKES = 'priorityLikes';

export const PURCHASE_TYPE_CONSUMABLE = 'consumable';
export const PURCHASE_TYPE_SUBSCRIPTION = 'subscription';

export const PLATFORM_TYPE_LITE = 'lite';
export const PLATFORM_TYPE_WEB = 'web';
export const PLATFORM_TYPE_WEB_BRAINTREE_PAYPAL = 'web_braintree_paypal';
export const PLATFORM_TYPE_ANDROID_BRAINTREE_PAYPAL = 'android_braintree_paypal';
export const PLATFORM_TYPE_ANDROID_CC = 'android_cc';
export const PLATFORM_TYPE_APPLE_CC = 'apple_cc';
export const PLATFORM_TYPE_GIFT_CARD = 'web_blackhawk_giftcard';

export const PRODUCT_TYPE_BOOST_SUBSCRIPTION = 'boost_subscription';

// we camelize keys in the api response transform
export const PRODUCT_TYPE_BOOST_SUBSCRIPTION_SCHEMA_KEY = 'boostSubscription';
export const PRODUCT_TYPE_SELECT_SUBSCRIPTION_SCHEMA_KEY = 'selectSubscription';

export const TIERED_SUB_TYPE = 'tieredSubscription';
export const CONSUMABLE_SUB_TYPE = 'consumableSubscription';
export const TINDER_SELECT_SUB_TYPE = 'selectSubscription';

export type TieredSubscriptionTypes =
  | typeof PRODUCT_TYPE_PLUS
  | typeof PRODUCT_TYPE_GOLD
  | typeof PRODUCT_TYPE_PLATINUM;

export const PRODUCT_TYPES_TIERED_SUBSCRIPTION = [
  PRODUCT_TYPE_PLUS,
  PRODUCT_TYPE_GOLD,
  PRODUCT_TYPE_PLATINUM,
];

export const PRODUCT_TYPES_ALL_SUBSCRIPTION = [
  PRODUCT_TYPE_BOOST_SUBSCRIPTION,
  PRODUCT_TYPE_PLUS,
  PRODUCT_TYPE_GOLD,
  PRODUCT_TYPE_PLATINUM,
  PRODUCT_TYPE_SELECT_SUBSCRIPTION,
];

export const PRODUCT_TYPES_CONSUMABLE_SUBSCRIPTION = [PRODUCT_TYPE_BOOST_SUBSCRIPTION];
export const PRODUCT_TYPES_ALTERNATIVE_SUBSCRIPTION = [
  PRODUCT_TYPE_BOOST_SUBSCRIPTION,
  PRODUCT_TYPE_SELECT_SUBSCRIPTION,
];
export const PRODUCT_TYPES_PREMIUM_SUBSCRIPTION = [PRODUCT_TYPE_GOLD, PRODUCT_TYPE_PLATINUM];

export const SUPPORTED_PURCHASE_PLATFORMS: Set<string> = new Set([
  PLATFORM_TYPE_WEB,
  PLATFORM_TYPE_WEB_BRAINTREE_PAYPAL,
  PLATFORM_TYPE_ANDROID_CC,
  PLATFORM_TYPE_APPLE_CC,
]);

/**
 * Consumables product types
 */
export const PRODUCT_TYPES_CONSUMABLES = [
  PRODUCT_TYPE_BOOST,
  PRODUCT_TYPE_BOUNCER_BYPASS,
  PRODUCT_TYPE_PRIMETIME_BOOST,
  PRODUCT_TYPE_SUPERBOOST,
  PRODUCT_TYPE_SUPERLIKE,
  PRODUCT_TYPE_SWIPE_NOTE,
  PRODUCT_TYPE_READ_RECEIPT,
];

export const PRODUCT_TYPES_DYNO_ELIGIBLE = [
  PRODUCT_TYPE_BOOST,
  PRODUCT_TYPE_GOLD,
  PRODUCT_TYPE_PLUS,
  PRODUCT_TYPE_PLATINUM,
  PRODUCT_TYPE_SELECT_SUBSCRIPTION,
];

/**
 * Entity schemas define the top-level "nouns" that describe the shape of the data we use in the app.
 */

export const purchaseEntity = new EntitySchema(
  PURCHASES_ENTITY_KEY,
  {},
  {
    idAttribute: 'productId',
    processStrategy(value) {
      return {
        ...value,
        pricePerTerm: value.terms ? value.price / value.terms : value.price,
      };
    },
  }
);
export const purchasesArray = new ArraySchema(purchaseEntity);
